import React from "react";
import { Card } from "react-bootstrap";
import "../../multi-step-components/SelectOption/styles.scss";
import "./styles.scss";

const SelectOption = ({ type, image, handleClick, selected, activeImage }) => {
  return (
    <>
      <Card
        onClick={() => {
          handleClick(type);
        }}
        className={`oenHouseCard m-2 shadow-sm roof-type-card ${
          selected ? "selected-ownhouse-card" : ""
        } `}
      >
        <div className="select-opt-imag-div mb-5">
          <img src={selected ? activeImage : image} className="" alt={type} />
        </div>
        <span class={selected ? "text-orange" : ""}> {type}</span>
      </Card>
    </>
  );
};

export default SelectOption;
